
import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'

type DatePickerTextFieldProps = TextFieldProps & {
  isDirty?: boolean
  isReadOnlyRender?: boolean
}

const DatePickerTextField = React.forwardRef<HTMLDivElement, DatePickerTextFieldProps>(function DatePickerTextField(props, ref) {
  const { sx, isDirty, isReadOnlyRender, ...rest } = props
  return (
    <TextField
      {...rest}
      inputRef={ref}
      fullWidth
      variant='outlined'
      size='small'
      sx={{
        ...sx, // 🟢 Forward custom styles from DatePicker
        '& .MuiInputBase-root': {
          bgcolor: isReadOnlyRender ? 'background.section' : isDirty ? 'text.dirty' : 'background.input', // fallback if needed
        },
      }}
      InputProps={{ readOnly: isReadOnlyRender }}
    />
  )
})

export { DatePickerTextField }
